import { render, staticRenderFns } from "./solutionSystem.vue?vue&type=template&id=9baf9b7e&scoped=true&"
import script from "./solutionSystem.vue?vue&type=script&lang=js&"
export * from "./solutionSystem.vue?vue&type=script&lang=js&"
import style0 from "./solutionSystem.vue?vue&type=style&index=0&id=9baf9b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baf9b7e",
  null
  
)

export default component.exports